<template>
  <el-dialog :visible="visible" @close="$emit('update:visible', false)" class="dialog-w60" :class="$style['filter']">
    <el-form :model="form" :rules="rules" ref="form">
      <h2 class="text-center mt-0">Фильтр</h2>
      <div class="row">
        <div class="col-12 col-lg-6">
          <h3>Признак обработки</h3>
          <el-form-item prop="claimProcessed">
            <el-select v-model="form.claimProcessed"
                       clearable @clear="form.claimProcessed = null"
                       class="w-100"
                       placeholder="Выберите признак обработки">
              <el-option v-for="option in claimStatuses" :key="option.id" :label="option.label" :value="option.value.toString()" />
            </el-select>
          </el-form-item>
        </div>
        <div class="col-12 col-lg-6">
          <h3>Статус заказа</h3>
          <el-form-item prop="statusIds">
            <el-select v-model="form.statusIds"
                       class="w-100" size="medium"
                       multiple
                       filterable
                       collapse-tags
                       placeholder="Выберите статус заказа">
              <el-option v-for="status in statuses" :key="status.id" :label="status.title" :value="status.id.toString()" />
            </el-select>
          </el-form-item>
        </div>

        <div class="col-12 col-lg-6">
          <h3>Дата обработки</h3>
          <div class="row">
            <div class="col-6">
              <el-date-picker v-model="form.claimProcessingDateFrom" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                              class="w-100" placeholder="с" :pickerOptions="pickerOptions" />
            </div>
            <div class="col-6 pl-0">
              <el-date-picker v-model="form.claimProcessingDateTo" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                              class="w-100" placeholder="по" :pickerOptions="pickerOptions" />
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <h3>Дата рекламации</h3>
          <div class="row">
            <div class="col-6">
              <el-date-picker v-model="form.claimCreationDateFrom" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                              class="w-100" placeholder="с" :pickerOptions="pickerOptions" />
            </div>
            <div class="col-6 pl-0">
              <el-date-picker v-model="form.claimCreationDateTo" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                              class="w-100" placeholder="по" :pickerOptions="pickerOptions" />
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-6">
          <h3>Дата оказания услуги</h3>
          <div class="row">
            <div class="col-6">
              <el-date-picker v-model="form.workDateFrom" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                              class="w-100" placeholder="с" :pickerOptions="pickerOptions" />
            </div>
            <div class="col-6 pl-0">
              <el-date-picker v-model="form.workDateTo" type="date" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                              class="w-100" placeholder="по" :pickerOptions="pickerOptions" />
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <h3>Тип заказа</h3>
          <el-form-item prop="serviceIds">
            <el-select size="medium" class="w-100" filterable multiple collapse-tags
                       :loading="servicesDropFetchProgress"
                       v-model="form.serviceIds"
                       placeholder="Выберите услугу">
              <el-option v-for="option in servicesDropItems" :key="option.id" :label="option.displayName" :value="option.id.toString()" />
            </el-select>
          </el-form-item>
        </div>

        <div class="col-12 col-lg-6" v-if="$isAccess($userRoles.Admin, $userRoles.Specialist)">
          <h3>Подрядчик</h3>
          <el-form-item prop="contractorIds">
            <el-select size="medium" multiple filterable collapse-tags clearable
                       class="w-100"
                       v-model="form.contractorIds"
                       :loading="contractorsDropFetchProgress"
                       placeholder="Выберите подрядчика">
              <el-option
                v-for="option in contractorsDropItems"
                :key="option.id"
                :label="option.name"
                :value="option.id.toString()">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="col-12 col-lg-6" v-if="$isAccess($userRoles.Admin, $userRoles.Specialist, $userRoles.Dispatcher)">
          <h3>Исполнитель</h3>
          <el-form-item prop="contractorIds">
            <el-select size="medium" multiple filterable collapse-tags clearable
                       class="w-100"
                       v-model="form.workerId"
                       :loading="contractorsDropFetchProgress"
                       placeholder="Выберите исполнителя">
              <el-option
                v-for="option in workersDropItems"
                :key="option.id"
                :label="option.fullName"
                :value="option.id.toString()">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="col-12 col-lg-6">
          <h3>Магазин</h3>
          <el-form-item prop="shop">
            <el-input size="medium" placeholder="Магазин" v-model="form.shop" />
          </el-form-item>
        </div>

        <div class="col-12 col-lg-6">
          <h3>Причина отмены</h3>
          <el-form-item prop="reasonIds">
            <el-select v-model="form.cancellationReasonIds"
                       multiple filterable
                       collapse-tags class="w-100"
                       size="medium"
                       placeholder="Выберите причину отмены">
              <el-option v-for="item in cancellations" :key="item.id" :label="item.displayName" :value="item.id.toString()" />
            </el-select>
          </el-form-item>
        </div>
        <div class="col-12 col-lg-6">
          <h3>Причина рекламации</h3>
          <el-form-item prop="claimReasonIds">
            <el-select v-model="form.claimReasonIds"
                       multiple filterable
                       collapse-tags class="w-100"
                       size="medium"
                       placeholder="Выберите причину рекламации">
              <el-option v-for="item in claims" :key="item.id" :label="item.displayName" :value="item.id.toString()" />
            </el-select>
          </el-form-item>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12 col-lg-6 mx-auto mb-3 mb-lg-0">
          <el-button class="w-100" @click="onClear" :disabled="fetchProgress">Сбросить</el-button>
        </div>
        <div class="col-12 col-lg-6 mx-auto">
          <el-button class="w-100" type="primary" @click="onSubmit" :loading="fetchProgress">Применить</el-button>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import claimStatuses from '@/commons/constants/claimStatuses';
import { initialState } from '@/store/modules/orders';

const DEFAULT_FORM = () => {
  const form = initialState().filter;
  delete form.search;
  return form;
};

export default {
  props: {
    visible: Boolean,
    updateUrl: {
      type: Function,
      default: () => {},
    },
  },
  data: () => ({
    claimStatuses,
    form: { ...DEFAULT_FORM() },
    pickerOptions: {
      firstDayOfWeek: 1,
    },
    rules: {},
  }),
  computed: {
    ...mapGetters({
      fetchProgress: 'orders/fetchProgress',
      filter: 'orders/filter',
      statuses: 'orders/statuses',
      cancellations: 'orderCancellationReasonsDrop/items',
      claims: 'claimReasonsDrop/items',
      servicesDropItems: 'servicesDrop/items',
      servicesDropFetchProgress: 'servicesDrop/fetchProgress',
      contractorsDropItems: 'contractorsDrop/items',
      workersDropItems: 'contractorsDrop/workers',
      contractorsDropFetchProgress: 'contractorsDrop/fetchProgress',
    }),
  },
  methods: {
    ...mapMutations({
      setFilterValue: 'orders/setFilterValue',
      setPage: 'orders/setPage',
    }),
    ...mapActions({
      fetchItems: 'orders/fetchItems',
      fetchStatuses: 'orders/fetchStatuses',
      fetchCancellations: 'orderCancellationReasonsDrop/fetchItems',
      fetchClaims: 'claimReasonsDrop/fetchItems',
      servicesDropFetchItems: 'servicesDrop/fetchItems',
      contractorsDropFetchItems: 'contractorsDrop/fetchItems',
    }),
    fillForm() {
      for (const key in this.form) {
        this.form[key] = this.filter[key];
      }
    },
    onClear() {
      this.form = { ...DEFAULT_FORM() };
    },
    onSubmit() {
      for (const key in this.form) {
        this.setFilterValue({ key, value: this.form[key] });
      }
      this.setPage(1);
      this.updateUrl();
      this.fetchItems().then(() => {
        this.$emit('update:visible', false);
      });
    },
  },
  created() {
    this.fetchStatuses();
    this.fetchClaims();
    this.fetchCancellations();
    this.servicesDropFetchItems();
    this.contractorsDropFetchItems();
    this.fillForm();
  },
};
</script>
<style lang="scss" module>
.filter {
  h3 {
    font-size: 16px !important;
    margin: 12px 0;
  }
}
</style>
